import { gql } from '@apollo/client';

import {
  COMPANY_FIELDS,
  RESUME_CARD_FIELDS,
  STATE_COUNTS_FIELDS,
  VACANCY_CARD_FIELDS
} from './fields';

export const GET_PROFILE_FULL = gql`
  ${VACANCY_CARD_FIELDS}

  ${RESUME_CARD_FIELDS}

  ${STATE_COUNTS_FIELDS}

  ${COMPANY_FIELDS}

  query ProfileFull(
    $state: ProfileAdTabStatesEnum = ALL
    $adType: AdTypeEnum = null
  ) {
    profile {
      ... on UserProfile {
        id
        email
        walletBalance
        adsStateCounts(adType: $adType) {
          ...adsStateCounts
        }
        company {
          ...companyFields
        }
        ads(state: $state, adType: $adType) {
          nodes {
            ... on Resume {
              ...resumeCardFields
            }
            ... on Vacancy {
              ...vacancyCardFields
            }
          }
        }
        candidate {
          id
          firstName
          surname
          patronymic
          name
          gender
          age
          dateOfBirth
          email
          phones
          regionId
          educationId
          experienceId
          logoUrl
          __typename
        }
      }
    }
  }
`;

export const GET_PROFILE_MIN = gql`
  query ProfileMin {
    profile {
      ... on UserProfile {
        id
        email
        walletBalance
        company {
          id
          logoUrl
          name
          phones
          email
        }
        candidate {
          id
          firstName
          surname
          logoUrl
          email
          phones
          patronymic
          gender
          dateOfBirth
          regionId
          regionName
        }
      }
    }
  }
`;

export const GET_ADS_STATE_COUNTS = gql`
  ${STATE_COUNTS_FIELDS}

  query AdsStateCounts($adType: AdTypeEnum = null) {
    profile {
      ... on UserProfile {
        adsStateCounts(adType: $adType) {
          ...adsStateCounts
        }
      }
    }
  }
`;
